import React, { useState, useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom';
import useScrollToElement from './useScrollToElement';

import TopBar from '../components/TopBar'
import Footer from '../components/Footer'
import CopyableMailLink from '../components/CopyableMailLink'
import './WWA.css'

import H from '../assets/WWAH.webp'
import S from '../assets/WWAs.webp'
import AZ from '../assets/WWAaz.webp'

import T1 from '../assets/WWAt1.webp'
import T2 from '../assets/WWAt2.webp'
import T3 from '../assets/WWAt3.webp'
import T4 from '../assets/WWAt4.webp'
import I from '../assets/111.svg'
import MidPic from '../assets/wwa-midpic.webp'

import { motion as m } from "framer-motion";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import ScrollTrigger from 'gsap/ScrollTrigger';
import { useTranslation } from 'react-i18next';

gsap.registerPlugin(useGSAP);

const WWA = () => {
    
  const { i18n } = useTranslation();
  const { t } = useTranslation();

  
  const addHtml1 = t('WWA4');
  const addHtml2 = t('WWA6');
  const addHtml3=t('WWA8');
    //media query
    const [deviceWidth, setDeviceWidth] = useState(window.screen.width);

    useEffect(() => {
        const handleResize = () => {
            setDeviceWidth(window.screen.width);
        };
        window.addEventListener('resize', handleResize);
        window.addEventListener('orientationchange', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('orientationchange', handleResize);
        };
    }, []);

    //team scroll
    const scrollContainer = useRef(null);
    const [direction, setDirection] = useState(1); // 1 for right, -1 for left
    const [scrollAmount, setScrollAmount] = useState(0);
    const [isPaused, setIsPaused] = useState(false);

    function animateScroll() {
        // Initialize frameCount outside the function to keep its state across frames
        let frameCount = 0;

        function scroll() {
            if (scrollContainer.current && !isPaused) {
                const maxScrollLeft = scrollContainer.current.scrollWidth - scrollContainer.current.clientWidth;
                if ((scrollAmount >= maxScrollLeft && direction === 1) || (scrollAmount <= 0 && direction === -1)) {
                    setIsPaused(true);
                    setTimeout(() => {
                        setDirection(direction => -direction);
                        setIsPaused(false);
                    }, 1000); // Delay of 1 second before switching direction
                    return;
                }

                const newScrollAmount = scrollAmount + direction * 1.5; // Adjusting for slower speed
                scrollContainer.current.scrollLeft = newScrollAmount;

                // Only update state every 10 frames

                setScrollAmount(newScrollAmount);

                frameCount++; // Increment frame count
            }
            requestAnimationFrame(scroll);
        }

        // Start the animation loop
        requestAnimationFrame(scroll);
    }

    useEffect(() => {
        let animationFrameId = requestAnimationFrame(animateScroll);
        return () => cancelAnimationFrame(animationFrameId);
    }, [scrollAmount, direction, isPaused]);


    //sections navigation

    const location = useLocation();
    const elementId = location.hash.substring(1);

    // Use the custom hook
    useScrollToElement(elementId, location.key); // 'location.key' changes on each navigation, triggering the effect




    ///landing

    const topboxRef = useRef(null);
    const topboxRef1 = useRef(null);
    const topboxRef2 = useRef(null);
    const topimgRef = useRef(null);

    const storytopRef = useRef(null);
    const storymainRef = useRef(null);


    const aztopRef = useRef(null);
    const azmainRef = useRef(null);

    const teamRef = useRef(null);

    useGSAP(() => {
        // Register the plugin
        gsap.registerPlugin(ScrollTrigger);

        //landing animation for the 'top' section        

      /*  gsap.from([topimgRef.current], {
            opacity: 0,
            y: "+=50",
            delay: 0.5,
            stagger: 0.25,
            ease: "sine.out",
        });*/

        [storytopRef, storymainRef, aztopRef, azmainRef].forEach(ref => {
            ScrollTrigger.create({
                trigger: ref.current,
                start: "top 100%", //adjusting here 
                toggleActions: "play none none none",
                onEnter: () => {
                    gsap.from([ref.current], {
                        opacity: 0,
                        y: "+=50",
                        delay: 0.4,
                        duration: 0.8,
                        stagger: 0.2,
                        ease: "sine.out",
                        scrub: true,
                    });
                },
            });
        });


    }, []);


    ///dragging team members
    const sliderRef = useRef(null);

    useEffect(() => {
        const slider = sliderRef.current;
        let isDown = false;
        let startX;
        let scrollLeft;

        const handleMouseDown = (e) => {
            isDown = true;
            startX = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        };

        const handleMouseLeave = () => {
            isDown = false;
        };

        const handleMouseUp = () => {
            isDown = false;
        };

        const handleMouseMove = (e) => {
            if (!isDown) return;
            e.preventDefault();
            const x = e.pageX - slider.offsetLeft;
            const walk = (x - startX) * 3; // Adjust scroll speed here
            slider.scrollLeft = scrollLeft - walk;
        };

        if (slider) {
            slider.addEventListener('mousedown', handleMouseDown);
            slider.addEventListener('mouseleave', handleMouseLeave);
            slider.addEventListener('mouseup', handleMouseUp);
            slider.addEventListener('mousemove', handleMouseMove);

            // Cleanup function to remove event listeners
            return () => {
                slider.removeEventListener('mousedown', handleMouseDown);
                slider.removeEventListener('mouseleave', handleMouseLeave);
                slider.removeEventListener('mouseup', handleMouseUp);
                slider.removeEventListener('mousemove', handleMouseMove);
            };
        }
    }, []); // Empty dependency array means this effect runs once on mount only



    return (
        <m.div className="WWA"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .25 }}
        >
            <div style={{ backgroundImage: `url(${I})` }} className="WWA-top">
                <div className="WWA-top-header">{t('TopBar1')}</div>
                <div className="WWA-top-text">{t('WWA1')}</div>
                {/*<img loading="lazy" decoding="async" alt="" src={I} className="WWA-top-img"/>*/}
            </div>
            {/*<div className="WWA-rating">
                <div className="WWA-rating-element" ref={topboxRef}>
                    <div className="WWA-rating-element-number">1M+</div>
                    <div className="WWA-rating-element-text">{t('AboutP1dev')}</div>
                </div>

                <div className="WWA-rating-element" ref={topboxRef1}>
                    <div className="WWA-rating-element-number">93%</div>
                    <div className="WWA-rating-element-text">{t('AboutP2dev')}</div>
                </div>

                <div className="WWA-rating-element" ref={topboxRef2}>
                    <div className="WWA-rating-element-number">4.9</div>
                    <div className="WWA-rating-element-text">{t('AboutP3dev')}</div>
                </div>
            </div>*/}
            {deviceWidth > 767 &&
                <img loading="lazy" decoding="async" alt="" src={MidPic} className="WWA-toppicture" ref={topimgRef} />
            }
            <div id="aboutUs" className="WWA-story">
                <div className="WWA-story-top" ref={storytopRef}><span style={{ color: '#000' }}>{t('WWA2')} </span><span style={{ color: '#A2A2A2' }}> {t('WWA3')}</span></div>
                <div className="WWA-story-content">
                    {deviceWidth < 1024 &&
                        <img loading="lazy" decoding="async" alt="" style={{maxHeight: "300px"}} src={S} className="WWA-story-content-img" />}
                    <div className="WWA-story-content-text" ref={storymainRef} dangerouslySetInnerHTML={{ __html: addHtml1 }}></div>
                    {deviceWidth > 1023 &&
                        <img loading="lazy" decoding="async" alt="" style={{maxHeight: "300px"}}  src={S} className="WWA-story-content-img" />}
                </div>
            </div>
            {<div id="mv" className="WWA-mv">
               { /*<div className="WWA-mv-top">{t('WWA5')}</div>
                <div className="WWA-mv-bottom" dangerouslySetInnerHTML={{ __html: addHtml2 }}></div>*/}
            </div>
            
            
            }
            <div id="aze" className="WWA-az">
                {deviceWidth > 1023 &&
                    <img loading="lazy" decoding="async" alt="" src={AZ} className="WWA-az-img" />
                }

                <div className="WWA-az-text">
                    <div className="WWA-az-text-top" ref={aztopRef}>{t('WWA7')}</div>
                    <div className="WWA-az-text-bottom" ref={azmainRef} dangerouslySetInnerHTML={{ __html: addHtml3 }}></div>
                </div>
                {deviceWidth < 1024 &&
                    <img loading="lazy" decoding="async" alt="" src={AZ} className="WWA-az-img" />
                }
            </div>
            <div className="WWA-team">
                <div className="WWA-team-header">
                    <div className="WWA-team-header-top">{t('WWA9')}</div>
                    <div className="WWA-team-header-bottom">{t('WWA10')}</div>
                </div>
                <div className="WWA-team-elements" ref={sliderRef}>{/*
                    <div className="WWA-team-elements-element" ref={teamRef}>
                        <div style={{ backgroundImage: `url(${T1})` }} className="WWA-team-elements-element-img">
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team1')}</div>
                                <div className="WWA-team-element-element-container-bottom">{t('TeamPos1')}</div>
                            </div></div>

                    </div>
                    <div className="WWA-team-elements-element" ref={teamRef}>
                        <div style={{ backgroundImage: `url(${T2})` }} className="WWA-team-elements-element-img">
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team2')}</div>
                                <div className="WWA-team-element-element-container-bottom">{t('TeamPos2')}</div>
                            </div>
                        </div></div>
                    <div className="WWA-team-elements-element" ref={teamRef}>
                        <div style={{ backgroundImage: `url(${T3})` }} className="WWA-team-elements-element-img">
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team3')}</div>
                                <div className="WWA-team-element-element-container-bottom">{t('TeamPos3')}</div>
                            </div>
                        </div></div>
                    <div className="WWA-team-elements-element" ref={teamRef}>
                        <div style={{ backgroundImage: `url(${T4})` }} className="WWA-team-elements-element-img">
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team4')}</div>
                                <div className="WWA-team-element-element-container-bottom">{t('TeamPos4')}</div>
                            </div>
                        </div></div>
                    <div className="WWA-team-elements-element" ref={teamRef}>
                        <div style={{ backgroundImage: `url(${T4})` }} className="WWA-team-elements-element-img">

                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team5')}</div>
                                <div className="WWA-team-element-element-container-bottom">{t('TeamPos5')}</div>
                            </div>
                        </div></div>
                        
            */ }
            <div className='member-rows' style={{display: 'flex',  alignSelf: 'stretch'}}>
             <div className="WWA-team-element-element-container">
                
                                <div className="WWA-team-element-element-container-top">{t('Team1')}<br/><br/>
                                    <CopyableMailLink style={{fontSize: '14px', color: '#005C5D'}} email="khazart@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994502637010">{t('TeamP')}</a>*/}</div>
                                <div className="WWA-team-element-element-container-bottom">
                                    
                                    {t('TeamPos1')}
                                    </div>
                            </div>
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team2')}<br/><br/>
                                <CopyableMailLink style={{fontSize: '14px', color: '#005C5D'}} email="lana.gozalova@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994502236044">{t('TeamP')}</a>*/}</div>
                                <div className="WWA-team-element-element-container-bottom">
                                
                                    {t('TeamPos2')}</div>
                            </div>
                            
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team6')}<br/><br/>
                                  <CopyableMailLink style={{fontSize: '14px', color: '#005C5D'}} email="emin.rzayev@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994503111077">{t('TeamP')}</a>*/}</div>
                                <div className="WWA-team-element-element-container-bottom">
                                    {t('TeamPos6')}
                                    </div>
                            </div>
                            </div>
                            <div className="member-rows" style={{display: 'flex', alignSelf: 'stretch'}}>
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team3')}    <br/><br/>
                                    <CopyableMailLink style={{fontSize: '14px', color: '#005C5D'}} email="nbakhishova@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994512154746">{t('TeamP')}</a>*/}</div>
                                <div className="WWA-team-element-element-container-bottom">
                                
                                    {t('TeamPos3')}</div>
                            </div>
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team4')}       <br/><br/>
                                <CopyableMailLink style={{fontSize: '14px', color: '#005C5D'}} email="shamchiyevat@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994554260119">{t('TeamP')}</a>*/}</div>
                                <div className="WWA-team-element-element-container-bottom">
                                    {t('TeamPos4')}</div>
                            </div>
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team5')}  <br/><br/>
                                <CopyableMailLink style={{fontSize: '14px' , color: '#005C5D'}} email="elchin.suleymanov@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994558570712">{t('TeamP')}</a>*/}  </div>
                                <div className="WWA-team-element-element-container-bottom">
                                    {t('TeamPos5')}</div>
                            </div>
                            </div>
                            <div className="member-rows" style={{display: 'flex', alignSelf: 'stretch'}}>
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team7')}    <br/><br/>
                                    <CopyableMailLink style={{fontSize: '14px', color: '#005C5D'}} email="ulkar.mammadova@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994512154746">{t('TeamP')}</a>*/}</div>
                                <div className="WWA-team-element-element-container-bottom">
                                
                                    {t('TeamPos7')}</div>
                            </div>
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team8')}       <br/><br/>
                                <CopyableMailLink style={{fontSize: '14px', color: '#005C5D'}} email="vusal.rustamov@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994554260119">{t('TeamP')}</a>*/}</div>
                                <div className="WWA-team-element-element-container-bottom">
                                    {t('TeamPos8')}</div>
                            </div>
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team9')}  <br/><br/>
                                <CopyableMailLink style={{fontSize: '14px' , color: '#005C5D'}} email="orkhan.aghayev@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994558570712">{t('TeamP')}</a>*/}  </div>
                                <div className="WWA-team-element-element-container-bottom">
                                    {t('TeamPos9')}</div>
                            </div>
                            </div>
                            <div className="member-rows" style={{display: 'flex', alignSelf: 'stretch'}}>
                            <div className="WWA-team-element-element-container">
                                <div className="WWA-team-element-element-container-top">{t('Team10')}    <br/><br/>
                                    <CopyableMailLink style={{fontSize: '14px', color: '#005C5D'}} email="fidan.babayeva@khamsa-insurance.com">{t('TeamE')}</CopyableMailLink><br/>
                                {/*<a style={{fontSize: '14px', color: '#005C5D'}} href="tel:+994512154746">{t('TeamP')}</a>*/}</div>
                                <div className="WWA-team-element-element-container-bottom">
                                
                                    {t('TeamPos10')}</div>
                            </div>
                            </div>
            </div></div>
            <Footer />
        </m.div>
    )
}

export default WWA